import { Component, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AgentPaths, BasePaths, MemberPaths } from 'src/app/constants/routes';
import { AuthService } from 'src/app/services/auth.service';
import { AgentCreatePassword, BaseMemberSessionList } from 'src/app/models/password';
import { SessionService } from 'src/app/services/storage/session.service';
import { AgentLogin } from 'src/app/models/agent';
import { LoginType } from 'src/app/constants/login-type';
import { Session } from 'src/app/models/session';
import { Language } from 'src/app/constants/language';
import { LoginPayload } from '@app/models/member';

@Component({
    selector: 'mwp-validate-and-create-password',
    templateUrl: './validate-and-create-password.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValidateAndCreatePasswordComponent implements OnInit {

    public agentLoginId: number;
    public baseMemberSessionList: BaseMemberSessionList;
    public isAgent: boolean;
    public isValidateEmail: boolean;
    public isPasswordExpired: boolean;
    public token: string;
    public title: string;
    public jsonKeyTitle: string;
    public isFAQ: boolean;
    public loginType: LoginType = LoginType.NewPassword;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private sessionService: SessionService,
    ) { };


    ngOnInit() {
        const jsonKeyTitlePreFix = 'validateAndCreatePasswordTitle';
        this.activatedRoute.queryParams.subscribe(params => {
            this.token = params.token;
            this.isAgent = this.router.url.startsWith(BasePaths.ValidateAgentPassword) || this.router.url.startsWith(BasePaths.AgentPasswordExpired);
            this.isPasswordExpired = this.router.url.startsWith(BasePaths.AgentPasswordExpired);
            this.isValidateEmail = this.router.url.startsWith(BasePaths.ValidateAgentPassword);

            if (this.isAgent) {
                if (this.isPasswordExpired) {
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}YourPassWordExipred`;
                    this.title = 'Your Password Expired!';
                    this.agentLoginId = this.sessionService.session.agent.agentID;
                } else if (this.token) {
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}CreatePassword`;
                    this.title = 'Create Password';
                    this.authService.verifyAgentToken(this.token).subscribe({
                        next: (response: AgentLogin) => {
                            this.agentLoginId = response.agent.agentID;
                        },
                        error: () => this.router.navigateByUrl(BasePaths.Counselors)
                    });
                } else {
                    this.router.navigateByUrl(BasePaths.Counselors);
                }
            } else {
                if (this.token) {
                    this.jsonKeyTitle = `${jsonKeyTitlePreFix}CreatePassword`;
                    this.title = 'Create Password';
                    this.authService.verifyMemberToken(this.token).subscribe({
                        next: (response: BaseMemberSessionList) => {
                            this.baseMemberSessionList = response;
                        },
                        error: () => this.router.navigateByUrl(BasePaths.Members)
                    });
                } else {
                    this.router.navigateByUrl(BasePaths.Members);
                }
            }
        });
        this.sessionService.session.isFaqActive = false;
        this.sessionService.setSession();
        this.sessionService.$Session.subscribe((session: Session) => {
            this.isFAQ = session.isFaqActive;
        });
    }

    public submitPassword(data: AgentCreatePassword | LoginPayload): void {
        if (this.isAgent) {
            this.authService.resetAgentPassword(<AgentCreatePassword>data).subscribe(() => {
                this.router.navigateByUrl(AgentPaths.CounselorMemberLookup);
            });
        }
        else {
            if (this.isValidateEmail)
                this.authService.validateEmailPassword(<LoginPayload>data).subscribe((response: BaseMemberSessionList) => {
                    this.authService.resetMemberLogin(response.members[0], this.sessionService.session.operatingMode.version).subscribe(() => {
                        this.router.navigateByUrl(MemberPaths.Dashboard);
                    });
                });
            else
                this.authService.resetMemberPassword(<LoginPayload>data).subscribe((response: BaseMemberSessionList) => {
                    this.authService.resetMemberLogin(response.members[0], this.sessionService.session.operatingMode.version).subscribe(() => {
                        this.router.navigateByUrl(MemberPaths.Dashboard);
                    });
                });

        }
    }

    // clears session if user does not complete reset password 
    ngOnDestroy(): void {
        if (!this.sessionService?.session?.isLoggedIn) {
            this.sessionService.logout();
        }
    }
}